import { Button, List, ListItem, Typography } from "@mui/material"
import { KaziModal } from "../../../../Shared Components/Kazi/KaziModal"
import { ISubscription } from "../../../../Types/subcription"
import moment from "moment"
import { Dispatch, SetStateAction } from "react";
import { useToast } from "../../../../Hooks/useToast";
import { tier, useSubscription } from "../../../../Hooks/useSubscription";
import { useCancelSubscriptionMutation } from "../../../../Redux/api/subscriptionApi";
import { useUser } from "../../../../Hooks/useUser";
import { KaziButton } from "../../../../Shared Components/Kazi/KaziButton";

interface SubscriptionCancelationModalProps {
    open: boolean;
    handleClose: () => void;
    tier: tier;
    endDate: string;
}
export const SubscriptionCancelationModal = ({ open, handleClose, tier, endDate }:SubscriptionCancelationModalProps) => {
    /* ******************** Hooks ******************** */
    const { showToast } = useToast(); 
    const { locator, invalidateUser, user } = useUser();
    const { getSubscription } = useSubscription();
    const subscription = getSubscription(tier);
    const [cancelSubscription, {isLoading: cancelLoading }] = useCancelSubscriptionMutation();
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const handleCancel = () => {
        cancelSubscription({
            locator: locator!,
            body: {
                // @ts-ignore
                subscription_id: user?.stripe?.subscription_id
            }
        })
        .unwrap()
        .then(() =>{
            invalidateUser();
            handleClose();
            showToast({
                text: 'Your subscription has been cancelled.',
                variant: 'warning'
            });
        })
        .catch( err => {
            console.error("Error occured while cancelling subscription: ", err)
            showToast({
                text: "Unable to cancel subscription",
                variant: "error"
            })
        })
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <KaziModal 
            open={open}
            handleClose={handleClose}
            title="Do you want to cancel your subscription?"
            content={
                <>
                    <Typography variant="body-medium">When you cancel your {subscription?.title} subscription, you will lose access to capabilities such as</Typography>
                    <List disablePadding sx={{ listStyleType: 'disc', paddingLeft: 3 }} dense>
                        {
                            subscription?.features.map( (feature, idx) => (
                                idx > 0 && <ListItem key={feature} sx={{ display: 'list-item'}}><Typography variant="body-medium">{feature}</Typography></ListItem>
                            ))
                        }
                    </List>
                    <Typography variant="body-small" color={'black.200'}>If you cancel, you will have a Free subscription. You’ll see the changes reflected in your account the next time you’re billed on {moment(endDate).format('MMMM D, YYYY')}.</Typography>
                </>
            }
            actions={[
                <KaziButton 
                    variant="contained" 
                    onClick={handleCancel}
                    text="Cancel Subscription"
                    loading={{
                        isLoading: cancelLoading,
                        loadingText: "Cancelling..."
                    }}
                />
            ]}
        />
    )
}